"use client";

import { Button } from "@/components/ui/button";
import { RefreshCw, PlusCircle, LayoutList, LayoutGrid } from "lucide-react";

interface TimelineHeaderProps {
  showingCount: number;
  viewMode: "list" | "compact";
  isRefetching: boolean;
  onToggleViewMode: () => void;
  onRefresh: () => void;
  onOpenModal: () => void;
}

export const TimelineHeader = ({
  showingCount,
  viewMode,
  isRefetching,
  onToggleViewMode,
  onRefresh,
  onOpenModal,
}: TimelineHeaderProps) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 p-4 bg-card-50 border-b">
      <div className="flex items-center justify-between">
        <h3 className="font-medium text-card-foreground">
          Enhanced Timeline ({showingCount} items)
        </h3>
        <div className="flex items-center gap-2 sm:hidden">
          <Button
            variant="ghost"
            size="sm"
            onClick={onToggleViewMode}
            title="Switch timeline layout"
          >
            {viewMode === "list" ? (
              <LayoutGrid className="h-4 w-4" />
            ) : (
              <LayoutList className="h-4 w-4" />
            )}
          </Button>
          <Button onClick={onOpenModal} size="sm" title="Log activity">
            <PlusCircle className="h-4 w-4" />
          </Button>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={onToggleViewMode} className="hidden sm:flex">
          {viewMode === "list" ? (
            <>
              <LayoutGrid className="h-4 w-4 mr-1" />
              Compact
            </>
          ) : (
            <>
              <LayoutList className="h-4 w-4 mr-1" />
              Detailed
            </>
          )}
        </Button>

        <Button onClick={onRefresh} variant="ghost" size="sm" disabled={isRefetching}>
          <RefreshCw className={`h-4 w-4 mr-1 ${isRefetching ? "animate-spin" : ""}`} />
          Refresh
        </Button>

        <Button onClick={onOpenModal} size="sm" className="hidden sm:flex">
          <PlusCircle className="h-4 w-4 mr-1" />
          Log Activity
        </Button>
      </div>
    </div>
  );
};
